const mxStates = [
  {
    value: 'AG',
    label: 'Aguascalientes',
  },
  {
    value: 'BN',
    label: 'Baja California Norte',
  },
  {
    value: 'BS',
    label: 'Baja California Sur',
  },
  {
    value: 'CH',
    label: 'Coahuila',
  },
  {
    value: 'CI',
    label: 'Chihuahua',
  },
  {
    value: 'CL',
    label: 'Colima',
  },
  {
    value: 'CP',
    label: 'Campeche',
  },
  {
    value: 'CS',
    label: 'Chiapas',
  },
  {
    value: 'DF',
    label: 'Distrito Federal',
  },
  {
    value: 'DG',
    label: 'Durango',
  },
  {
    value: 'GE',
    label: 'Guerrero',
  },
  {
    value: 'GJ',
    label: 'Guanajuato',
  },
  {
    value: 'HD',
    label: 'Hidalgo',
  },
  {
    value: 'JA',
    label: 'Jalisco',
  },
  {
    value: 'MC',
    label: 'Michoacán',
  },
  {
    value: 'MR',
    label: 'Morelos',
  },
  {
    value: 'MX',
    label: 'México',
  },
  {
    value: 'NA',
    label: 'Nayarit',
  },
  {
    value: 'NL',
    label: 'Nuevo León',
  },
  {
    value: 'OA',
    label: 'Oaxaca',
  },
  {
    value: 'PU',
    label: 'Puebla',
  },
  {
    value: 'QE',
    label: 'Querétaro',
  },
  {
    value: 'QI',
    label: 'Quintana Roo',
  },
  {
    value: 'SI',
    label: 'Sinaloa',
  },
  {
    value: 'SL',
    label: 'San Luis Potosí',
  },
  {
    value: 'SO',
    label: 'Sonora',
  },
  {
    value: 'TA',
    label: 'Tamaulipas',
  },
  {
    value: 'TB',
    label: 'Tabasco',
  },
  {
    value: 'TL',
    label: 'Tlaxcala',
  },
  {
    value: 'VC',
    label: 'Veracruz',
  },
  {
    value: 'YU',
    label: 'Yucatán',
  },
  {
    value: 'ZA',
    label: 'Zacatecas',
  },
];

export default mxStates;
